/**
 * @file login模块路由配置
 */

// 登录验证
const Login = (resolve) =>
  import(/* webpackChunkName: "login" */ '../views/login/login');

export default [
  { name: 'login', path: '/login', component: Login, meta: { title: '登录' } },
];
